import Ending from './Ending';

export default Ending;
